import React from "react";
import { Route, Routes } from "react-router-dom";
import { UserRoles } from "../../../constants/userRoles";
import { PrivateRoute } from "../../../keycloak";
import { ClientDetails } from "./ClientDetails/ClientDetails";
import { ClientEdit } from "./ClientEdit/ClientEdit";

export const ClientView = () => {
  return (
    <Routes>
      <Route path="details">
        <Route
          element={
            <PrivateRoute
              roles={{
                dcs_client: [UserRoles.CLIENT_UPDATE],
              }}
            />
          }
        >
          <Route path="edit" element={<ClientEdit />} />
        </Route>
        <Route path="" element={<ClientDetails />} />
      </Route>
    </Routes>
  );
};
